/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import _ from "lodash";
import validator from "validator";
import CloseIcon from "@mui/icons-material/Close";
import { Add as AddIcon, Refresh, Search } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";
import { ZoomIn, ZoomOut, RestartAlt } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Avatar,
  Paper,
  Typography,
  FormControl,
  TextareaAutosize,
  Box,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
  Card,
  CardContent,
  FormControlLabel,
  Checkbox,
  Modal,
  IconButton,
  Breadcrumbs as MuiBreadcrumbs,
  Link,
  Divider as MuiDivider,
  Autocomplete,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";

import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Formik, getIn } from "formik";
import DocumentUpload from "../components/DocumentUpload";
import axios from "../../CustomAxios";
import { connect } from "react-redux";
import Loading from "../components/Loading";
import swal from "sweetalert";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;

let states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function Update({
  user,
  details,
  id,
  plates,
  inventory,
  urls,
  up,
  setup,
  setUrls,
}) {
  const [is_deleted, setIsDeleted] = useState(details.is_deleted);
  const [message, setMessage] = useState("");
  const [update, setUpdate] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);
  const [err, setErr] = useState("");
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [selectedPlates, setSelectedPlates] = useState([]);
  const [prices, setPrices] = useState(plates);
  const [success, setSuccess] = useState(false);
  const [changes, setChanges] = useState([]);

  const [expanded, setExpanded] = useState(details?.default_address);

  const handleExpandedChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [notification, setNotification] = useState(
    details?.notification_setting
  );
  const [state, setState] = useState({
    op: false,
    vertical: "top",
    horizontal: "center",
  });
  const [loader, setLoader] = useState(false);
  const { vertical, horizontal, op } = state;
  const handleClick = (newState) => () => {
    setState({ op: true, ...newState });
  };
  const handleCloseSnack = () => {
    setState({ ...state, op: false });
  };
  const handleClose = () => setOpen(false);
  const [del, setDelete] = useState(false);
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const [u, setU] = useState();
  const [type, setType] = useState();
  const handleOpen = (url, type) => {
    // if(type!=="pdf"){

    setU(url);
    setType(type);
    setOpen(true);
    setModalImgHeight(70);
    // }else{
    // window.open(url)
    // }
  };
  const [modalImgHeight, setModalImgHeight] = useState(70);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const [open, setOpen] = useState(false);
  const [documents, setDocuments] = useState({});
  const [images, setImages] = useState({});
  const [profile, setProfile] = useState();
  const [imgValue, setImgVal] = useState(null);

  const inputFile = useRef(null);
  const onButtonClick = () => {
    inputFile.current.click();
  };
  const [profileLoader, setProfileLoader] = useState(false);
  const [documentLoader, setDocumentLoader] = useState(false);

  useEffect(() => {
    let pf = urls.find((item) => item.name === "profile_picture");
    setProfile(pf !== undefined ? pf.url : "");
  }, []);

  const handleProfileChange = async () => {
    try {
      setProfileLoader(true);
      let formDt = new FormData();
      formDt.set("profile_picture", imgValue);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      const { data } = await axios.post(
        `/api/v1/${authData?.type}/media/customer_company/${id}`,
        formDt,
        config
      );

      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Documents Added Successfully");
        snackRef.current.click();
        // window.location.reload();
        setUrls([]);
        setProfileLoader(false);
      }
    } catch (error) {
      setErr(error.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(error);
      setProfileLoader(false);
    }
  };
  const getCompaniesByPanNumber = async (pan_number) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData.type}/customer_company/companies/${pan_number}`,
        config
      );
      let text = ``;
      data?.data?.map((cmp, i) => {
        text += `${i + 1} ${cmp.name} \n`;
      });
      return text;
    } catch (e) {
      setErr(e.response.data.error || "Something went wrong");
      console.log(e);
      snackRef.current.click();
    }
  };

  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };
  const formData = new FormData();

  const deleteDocument = async (key) => {
    try {
      // setLoader(true);
      setDocumentLoader(true);

      setDelete(false);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.delete(
        `/api/v1/${authData?.type}/media/customer_company/${id}/${key}`,
        config
      );
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        setUrls([]);
        setup(up + 1);
        setDocumentLoader(false);

        // window.location.reload();
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      setDocumentLoader(false);

      console.log(e);
    }
  };

  const addDocuments = async () => {
    try {
      setDocumentLoader(true);

      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        // setLoader(true);
        handleDownDoc();
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        const { data } = await axios.post(
          `/api/v1/${authData?.type}/media/customer_company/${id}`,
          formData,
          config
        );
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents Added Successfully");
          snackRef.current.click();
          setUrls([]);
          setup(up + 1);
          setDocumentLoader(false);

          // window.location.reload();
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
      setDocumentLoader(false);
    }
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: 400,
    bgcolor: "background.paper",
    // bgcolor: 'transparent',
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const submit = async (values) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      const { data } = await axios.put(
        `/api/v1/${authData?.type}/customer_company/${id}`,
        {
          email_address: values?.email_address,
          name: values?.name,
          phone_number: values?.phone_number,
          landline_number: values?.landline_number,
          addresses: values ? JSON.stringify(values.addresses) : [],
          default_address: values?.default_address,
          gst_number: values?.gst_number,
          pan_number: values?.pan_number,
          credit_sum: values?.credit_sum,
          description: values?.description,
          is_deleted: is_deleted,
        },
        config
      );
      if (data.success) {
        setErr("");
        setSuccess(true);
        snackRef.current.click();
        navigate("/dashboard/company/customer-companies", {
          state: {
            message: "Customer Company Details Updated Successfully",
            success: true,
          },
        });
      }
      setLoader(false);
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
      setSuccess(false);
      console.log(e);
    }
  };

  useEffect(() => {
    let selected = [];
    prices.map((pl) => {
      selected.push(pl.plate_id);
    });
    setSelectedPlates(selected);
  }, []);

  const removePlate = (i, id) => {
    const updatedPrices = [...prices];
    updatedPrices[i] = { ...prices[i], deactivated: true };

    setPrices(updatedPrices);
    // if (id) {
    //   setSelectedPlates((prev) => [...prev.filter((x) => x !== id)]);
    // }
    // setPrices((prev) => [...prev.slice(0, i), ...prev.slice(i + 1)]);
  };

  const restorePlate = (i, id) => {
    const updatedPrices = [...prices];
    updatedPrices[i] = { ...prices[i], deactivated: false };

    setPrices(updatedPrices);
  };

  const priceHandle = (i, obj) => (e) => {
    let price = [...prices];
    if (obj === "plate_id") {
      let plt_detail = inventory.filter((k) => k._id === e.target.value);

      price[i][obj] = e.target.value;
      price[i]["height"] = plt_detail[0].height;
      price[i]["width"] = plt_detail[0].width;
      price[i]["thickness"] = plt_detail[0].thickness;
      price[i]["company"] = plt_detail[0].company;

    } else {
      if (obj === "gripper") {
        if (e.target.value <= 99.99 && e.target.value >= 0.0) {
          price[i][obj] = parseFloat(e.target.value);
        }
      } else {
        price[i][obj] = parseInt(e.target.value !== "" ? e.target.value : 0);
      }
    }
    setPrices(price);
    let selected = [];
    price.map((pl) => {
      selected.push(pl.plate_id);
    });
    setSelectedPlates(selected);
  };
  const addPrice = () => {
    setPrices((prev) => [
      ...prev,
      { baking_cost: 0, print_cost: 0, selling_cost: 0 },
    ]);
  };

  const updateNotifications = async () => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${authData?.type}/customer_company/${id}/notification_setting`,
        {
          status_update_to_new: notification.status_update_to_new,
          status_update_to_studio: notification.status_update_to_studio,
          status_update_to_ctp_impose: notification.status_update_to_ctp_impose,
          status_update_to_ctp: notification.status_update_to_ctp,
          status_update_to_delivery: notification.status_update_to_delivery,
          status_update_to_customer_accept:
            notification.status_update_to_customer_accept,
          status_update_to_payment: notification.status_update_to_payment,
          status_update_to_billing: notification.status_update_to_billing,
        },
        config
      );
      if (data.success) {
        setMessage("Notification Status Updated Successfully");
        setSuccess(true);
        setErr("");
        snackRef.current.click();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const updateDetails = async () => {
    try {
      // setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      let tempChanges = changes;
      prices.map((e) => {
        tempChanges.push({
          plateId: e.plate_id,
          baking_cost: e.baking_cost,
          gripper: e.gripper,
          selling_cost: e.selling_cost,
          deactivated: e.deactivated,
        });
      });

      const { data } = await axios.put(
        `/api/v1/${userData.type}/customer_company/${details._id}/plate`,
        { plates: prices },
        config
      );

      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        setUpdate(false);
        setMessage("Plate Details Updated Successfully");
        snackRef.current.click();
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  const handleNotification = (event) => {
    setNotification({
      ...notification,
      [event.target.name]: event.target.checked,
    });
  };

  function onAddAddress(values, setValues) {
    // update dynamic form
    const addresses = [...values.addresses];
    let newAddress = {
      address_line_one: "",
      address_line_two: "",
      pincode: "",
      state: "",
      city: "",
    };
    addresses.push(newAddress);
    setValues({ ...values, addresses });
  }

  function onRemoveAddress(index, values, setValues) {
    // update dynamic form
    const addresses = [...values.addresses];
    if (addresses.length > 1) {
      addresses.splice(index, 1);
    }
    let default_address = values.default_address;
    if (default_address === index) {
      default_address -= 1;
    }
    setValues({ ...values, default_address, addresses });
  }

  return (
    <Formik
      initialValues={{
        email_address: details?.email_address,
        name: details?.name,
        description: details?.description,
        phone_number: details?.phone_number,
        landline_number: details?.landline_number,
        gst_number: details?.gst_number,
        addresses: details?.addresses,
        default_address: details?.default_address,
        pan_number: details?.pan_number,
        credit_sum: details?.credit_sum,
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email_address: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        name: Yup.string().max(255).required("name is required"),
        addresses: Yup.array().of(
          Yup.object().shape({
            address_line_one: Yup.string()
              .max(1000)
              .required("Address Line 1 is required"),
            address_line_two: Yup.string()
              .max(1000)
              .required("Address Line 2 is required"),
            pincode: Yup.string()
              .required("Pincode is required")
              .length(6, "Pincode should have 6 digits"),
            state: Yup.string().required("State is required"),
            city: Yup.string().required("City is required"),
          })
        ),
        gst_number: Yup.string()
          .length(15, "Should have 15 character")
          .required("GST number is required"),
        pan_number: Yup.string()
          .required("PAN Number is Required")
          .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number"),
        description: Yup.string().max(1000).required("Description is required"),

        phone_number: Yup.string()
          .required("Phone Number is required")
          .matches(/^(((\+){1}91){1})?[6-9]{1}[0-9]{9}$/, {
            message: "Invalid Indian number",
            excludeEmptyString: false,
          }),
        credit_sum: Yup.string().required("Credit Term is required"),
      })}
      onSubmit={async (
        values,
        { setErrors, setStatus, setSubmitting, resetForm }
      ) => {
        try {
          const data = await getCompaniesByPanNumber(values.pan_number);
          if (data.length > 0) {
            swal({
              title: "Pan card already exist",
              text: `Following companies are registered with same pan card, do you still want to proceed? \n \n ${data}`,
              icon: "warning",
              buttons: ["No", "Yes"],
            }).then((res) => {
              if (res) {
                submit(values);
              }
            });
          } else {
            submit(values);
          }
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        touched,
        values,
        setValues,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          <Button
            ref={snackRef}
            style={{ display: "none" }}
            onClick={handleClick({ vertical: "top", horizontal: "center" })}
          >
            Click
          </Button>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={op}
            onClose={handleCloseSnack}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity="error">
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity="success">
                {message}
              </Alert>
            ) : null}
          </Snackbar>
          {!loader ? (
            <div>
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Update Customer Company
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <BigAvatar
                          onClick={onButtonClick}
                          style={{ cursor: "pointer" }}
                          src={profile}
                        />
                        <input
                          type="file"
                          id="file"
                          ref={inputFile}
                          accept=".png, .jpg, .jpeg"
                          onChange={(e) => {
                            setProfile(URL.createObjectURL(e.target.files[0]));
                            setImgVal(e.target.files[0]);
                          }}
                          style={{ display: "none" }}
                        />
                        <Typography
                          component="h1"
                          variant="h4"
                          align="center"
                          gutterBottom
                        >
                          <Button
                            variant="outlined"
                            onClick={handleProfileChange}
                            disabled={profileLoader}
                          >
                            {profileLoader ? (
                              <>
                                Updating Profile Picture{" "}
                                <CircularProgress
                                  size={20}
                                  style={{ marginLeft: "8px" }}
                                />
                              </>
                            ) : (
                              "Update Profile picture"
                            )}
                          </Button>
                        </Typography>
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          fullWidth
                          type="text"
                          name="name"
                          label="name"
                          value={values.name}
                          error={Boolean(touched.name && errors.name)}
                          helperText={touched.name && errors.name}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="description"
                          fullWidth
                          label="Description"
                          value={values.description}
                          error={Boolean(
                            touched.description && errors.description
                          )}
                          helperText={touched.description && errors.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="email"
                          name="email_address"
                          label="Email address"
                          value={values.email_address}
                          error={Boolean(
                            touched.email_address && errors.email_address
                          )}
                          fullWidth
                          helperText={
                            touched.email_address && errors.email_address
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="phone_number"
                          label="Phone Number"
                          value={values.phone_number}
                          error={Boolean(
                            touched.phone_number && errors.phone_number
                          )}
                          fullWidth
                          helperText={
                            touched.phone_number && errors.phone_number
                          }
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="landline_number"
                          label="Landline Number"
                          value={values.landline_number}
                          fullWidth
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>

                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="credit_sum"
                          label="Credit Term"
                          value={values.credit_sum}
                          fullWidth
                          error={Boolean(
                            touched.credit_sum && errors.credit_sum
                          )}
                          helperText={touched.credit_sum && errors.credit_sum}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="gst_number"
                          label="GST Number"
                          value={values.gst_number}
                          error={Boolean(
                            touched.gst_number && errors.gst_number
                          )}
                          fullWidth
                          helperText={touched.gst_number && errors.gst_number}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        <TextField
                          type="text"
                          name="pan_number"
                          label="PAN Number"
                          value={values.pan_number}
                          error={Boolean(
                            touched.pan_number && errors.pan_number
                          )}
                          fullWidth
                          helperText={touched.pan_number && errors.pan_number}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} lg={12} md={12}>
                        {values.addresses.map((address, index) => {
                          const addressOne = `addresses[${index}].address_line_one`;
                          const touchedAddressOne = getIn(touched, addressOne);
                          const errorAddressOne = getIn(errors, addressOne);

                          const addressTwo = `addresses[${index}].address_line_two`;
                          const touchedAddressTwo = getIn(touched, addressTwo);
                          const errorAddressTwo = getIn(errors, addressTwo);

                          const pinCode = `addresses[${index}].pincode`;
                          const touchedPinCode = getIn(touched, pinCode);
                          const errorPinCode = getIn(errors, pinCode);

                          const stateInput = `addresses[${index}].state`;
                          const touchedState = getIn(touched, stateInput);
                          const errorState = getIn(errors, stateInput);

                          const city = `addresses[${index}].city`;
                          const touchedCity = getIn(touched, city);
                          const errorCity = getIn(errors, city);

                          return (
                            <Accordion
                              expanded={expanded === index}
                              onChange={handleExpandedChange(index)}
                              key={index}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography>Address {index + 1}</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid item xs={12} lg={12} md={12}>
                                  <TextField
                                    fullWidth
                                    name={addressOne}
                                    value={address.address_line_one}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label={"Address Line 1"}
                                    error={Boolean(
                                      touchedAddressOne && errorAddressOne
                                    )}
                                    helperText={
                                      touchedAddressOne && errorAddressOne
                                        ? errorAddressOne
                                        : ""
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} mt={5} lg={12} md={12}>
                                  <TextField
                                    fullWidth
                                    name={addressTwo}
                                    value={address.address_line_two}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label={"Address Line 2"}
                                    error={Boolean(
                                      touchedAddressTwo && errorAddressTwo
                                    )}
                                    helperText={
                                      touchedAddressTwo && errorAddressTwo
                                        ? errorAddressTwo
                                        : ""
                                    }
                                  />
                                </Grid>
                                <Grid item xs={12} mt={5} lg={12} md={12}>
                                  <TextField
                                    fullWidth
                                    name={pinCode}
                                    value={address.pincode}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label={"Pincode"}
                                    error={Boolean(
                                      touchedPinCode && errorPinCode
                                    )}
                                    helperText={
                                      touchedPinCode && errorPinCode
                                        ? errorPinCode
                                        : ""
                                    }
                                  />
                                </Grid>

                                <Grid item xs={12} mt={5} md={12} lg={12}>
                                  <FormControl
                                    fullWidth
                                    error={Boolean(touchedState && errorState)}
                                  >
                                    <Autocomplete
                                      id="combo-box-demo"
                                      options={states}
                                      value={address.state}
                                      onChange={(event, newValue) => {
                                        setFieldValue(
                                          stateInput,
                                          newValue || ""
                                        );
                                      }}
                                      onBlur={handleBlur}
                                      getOptionLabel={(option) => option}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          error={Boolean(
                                            touchedState && errorState
                                          )}
                                          helperText={
                                            touchedState && errorState
                                              ? errorState
                                              : ""
                                          }
                                          label="Select State"
                                        />
                                      )}
                                    />
                                  </FormControl>
                                </Grid>

                                <Grid item xs={12} mt={5} lg={12} md={12}>
                                  <TextField
                                    fullWidth
                                    name={city}
                                    value={address.city}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label={"City"}
                                    error={Boolean(touchedCity && errorCity)}
                                    helperText={
                                      touchedCity && errorCity ? errorCity : ""
                                    }
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  mt={5}
                                  mb={5}
                                  lg={12}
                                  md={12}
                                >
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={
                                            index === values.default_address
                                          }
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              setFieldValue(
                                                "default_address",
                                                index
                                              );
                                            } else {
                                              setFieldValue(
                                                "default_address",
                                                0
                                              );
                                            }
                                          }}
                                        />
                                      }
                                      label="Default Address"
                                    />
                                  </FormGroup>
                                </Grid>

                                <Grid container justifyContent={"flex-end"}>
                                  <div>
                                    {index !== 0 && (
                                      <Button
                                        sx={{ mr: 3 }}
                                        onClick={() => {
                                          onRemoveAddress(
                                            index,
                                            values,
                                            setValues
                                          );
                                        }}
                                        color="error"
                                        variant="outlined"
                                        endIcon={<DeleteIcon />}
                                      >
                                        Remove Address
                                      </Button>
                                    )}

                                    {values.addresses.length === index + 1 && (
                                      <Button
                                        onClick={() => {
                                          onAddAddress(values, setValues);
                                        }}
                                        variant="outlined"
                                        endIcon={<AddIcon />}
                                      >
                                        Add Address
                                      </Button>
                                    )}
                                  </div>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          );
                        })}
                      </Grid>

                      {(authData.type === "super_admin" || user?.role?.permissions?.includes("delete_customer_company")) && <Grid item xs={12} lg={3} md={3}>
                        <FormControl
                          fullWidth
                          component="fieldset"
                          variant="standard"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={is_deleted}
                                onChange={(e) => setIsDeleted(e.target.checked)}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            }
                            label={"Is Deleted"}
                          />
                        </FormControl>
                      </Grid>}
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>

              {user?.role?.permissions?.includes(
                "customer_company_plate_list_view"
              ) || authData?.type === "super_admin" ? (
                <Card mb={6}>
                  <CardContent>
                    <form noValidate autoComplete="off">
                      <Paper elevation={3} style={{ padding: "2%" }}>
                        <Grid container spacing={5}>
                          <Grid item xs={12} lg={12} md={12}>
                            <Typography variant="h4" gutterBottom>
                              Plate Price Details
                            </Typography>
                          </Grid>
                          {!prices.length ? (
                            <Grid item xs={12} md={12} lg={12}>
                              <Typography variant="h3">
                                No Plates Added
                              </Typography>
                            </Grid>
                          ) : (
                            prices.map((pl, i) => {
                              const check = [];
                              if (selectedPlates.length) {
                                selectedPlates.map((p) => {
                                  check.push(p);
                                });
                              }
                              return (
                                <>
                                  <Grid item xs={11} md={11} lg={11}>
                                    <FormControl fullWidth>
                                      <Select
                                        id="search-field"
                                        value={pl.plate_id || ""}
                                        // name={pl.height+"X"+pl.width+"X"+pl.thickness}
                                        onChange={priceHandle(i, "plate_id")}
                                        displayEmpty
                                        inputProps={{ readOnly: !update }}
                                      >
                                        <MenuItem value="" disabled>
                                          Select Plate
                                        </MenuItem>
                                        {inventory.map((plate) => {
                                          if (check.includes(plate._id)) {
                                            return (
                                              <MenuItem
                                                disabled
                                                value={plate._id}
                                                // name={plate.height+"X"+plate.width+"X"+plate.thickness}
                                              >
                                                {plate.height}X{plate.width}X
                                                {plate.thickness} ||{" "}
                                                {plate.brand.name} ||{" "}
                                                {plate.technology.name} ||{" "}
                                                {plate.company}
                                              </MenuItem>
                                            );
                                          } else {
                                            return (
                                              <MenuItem value={plate._id}>
                                                {plate.height}X{plate.width}X
                                                {plate.thickness} ||{" "}
                                                {plate.brand.name} ||{" "}
                                                {plate.technology.name} ||{" "}
                                                {plate.company}
                                              </MenuItem>
                                            );
                                          }
                                        })}
                                      </Select>
                                      <FormHelperText
                                        sx={{ color: pl.deactivated && "red" }}
                                      >
                                        {pl.deactivated
                                          ? "Deactivated Plate"
                                          : "Select Plate"}
                                      </FormHelperText>
                                    </FormControl>
                                  </Grid>
                                  {update ? (
                                    <Grid item xs={1} md={1} lg={1}>
                                      <div style={{ marginTop: 8 }}>
                                        {pl.deactivated ? (
                                          <Refresh
                                            color="success"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              restorePlate(i, pl.plate_id);
                                            }}
                                          />
                                        ) : (
                                          <CloseIcon
                                            color="error"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              removePlate(i, pl.plate_id);
                                            }}
                                          />
                                        )}
                                      </div>
                                    </Grid>
                                  ) : null}
                                  <Grid item xs={12} lg={3} md={6}>
                                    <TextField
                                      id="standard-number"
                                      label="Baking Cost"
                                      inputProps={{ readOnly: !update }}
                                      value={pl.baking_cost || "0"}
                                      onChange={priceHandle(i, "baking_cost")}
                                      type="number"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} lg={3} md={6}>
                                    <TextField
                                      id="standard-number"
                                      label="Print Cost"
                                      inputProps={{ readOnly: !update }}
                                      value={pl.print_cost || "0"}
                                      onChange={priceHandle(i, "print_cost")}
                                      type="number"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} lg={3} md={6}>
                                    <TextField
                                      id="standard-number"
                                      label="Selling Cost"
                                      inputProps={{ readOnly: !update }}
                                      value={pl.selling_cost || "0"}
                                      onChange={priceHandle(i, "selling_cost")}
                                      type="number"
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} lg={3} md={6}>
                                    <TextField
                                      id="standard-number"
                                      label="Gripper"
                                      inputProps={{ readOnly: !update }}
                                      value={pl.gripper || ""}
                                      onChange={priceHandle(i, "gripper")}
                                      type="number"
                                      fullWidth
                                    />
                                  </Grid>
                                </>
                              );
                            })
                          )}
                          <br />
                          {update ? (
                            <Grid item xs={12} lg={12} md={12}>
                              <Button
                                onClick={addPrice}
                                mr={2}
                                variant="contained"
                                color="primary"
                              >
                                Add Plate
                                <AddIcon />
                              </Button>
                            </Grid>
                          ) : user?.role?.permissions?.includes(
                              "customer_company_plate_list_update"
                            ) || authData?.type === "super_admin" ? (
                            <Grid item xs={12} lg={12} md={12}>
                              <Button
                                onClick={() => setUpdate(true)}
                                mr={2}
                                variant="contained"
                                color="primary"
                              >
                                Update Plate Details
                              </Button>
                            </Grid>
                          ) : null}
                          {update ? (
                            <Grid item xs={12} lg={12} md={12}>
                              <Button
                                onClick={updateDetails}
                                mr={2}
                                variant="contained"
                                color="primary"
                              >
                                Save Changes
                              </Button>
                            </Grid>
                          ) : null}
                        </Grid>
                      </Paper>
                    </form>
                  </CardContent>
                </Card>
              ) : null}

              <Modal open={open} onClose={handleClose}>
                <Card sx={style}>
                  <CardContent>
                    <Paper>
                      <Grid container justifyContent="center" spacing={5}>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <IconButton
                            onClick={() =>
                              setModalImgHeight(modalImgHeight + 5)
                            }
                          >
                            <ZoomIn />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              setModalImgHeight(modalImgHeight - 5)
                            }
                          >
                            <ZoomOut />
                          </IconButton>
                          <IconButton onClick={() => setModalImgHeight(70)}>
                            <RestartAlt />
                          </IconButton>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            maxHeight: "72.5vh",
                            overflowY: "scroll",
                          }}
                        >
                          {type !== "pdf" ? (
                            <Box
                              component={"img"}
                              src={u}
                              height={modalImgHeight.toString() + "vh"}
                              width="auto"
                            />
                          ) : (
                            <iframe
                              height={(modalImgHeight + 420).toString() + "vh"}
                              width={(modalImgHeight + 420).toString() + "vh"}
                              src={u}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>
              </Modal>
              <Modal
                open={openAddDoc}
                onClose={handleDownDoc}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    align="center"
                    color="primary"
                  >
                    Add Documents
                  </Typography>
                  <DocumentUpload
                    documents={documents}
                    setDocuments={setDocuments}
                    images={images}
                    setImages={setImages}
                  />
                  <Button onClick={addDocuments}>Add</Button>
                </Box>
              </Modal>
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h4" gutterBottom>
                          Document Details
                        </Typography>
                      </Grid>
                      {!urls.length ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            No Documents Added
                          </Typography>
                        </Grid>
                      ) : null}
                      {documentLoader ? (
                        "Loading documents"
                      ) : (
                        <>
                          {urls &&
                            urls.map((document, i) => {
                              if (urls[i]?.name !== "profile_picture") {
                                return (
                                  <Paper
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      width: "100%",
                                      marginTop: "10px",
                                    }}
                                    mt={3}
                                  >
                                    <Box
                                      component="img"
                                      width="90px"
                                      height="80px"
                                      onClick={() =>
                                        handleOpen(urls[i]?.url, urls[i]?.type)
                                      }
                                      src={
                                        urls[i]?.type === "pdf"
                                          ? "/static/img/images/pdf.png"
                                          : urls[i]?.url
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                    <TextField
                                      fullWidth
                                      margin="dense"
                                      m={2}
                                      style={{ marginLeft: 32, width: "100%" }}
                                      inputProps={{ readOnly: true }}
                                      id="standard-required"
                                      label="Document Name"
                                      value={urls[i]?.name || ""}
                                    />
                                    {!del ? (
                                      <Mob>
                                        <Grid item>
                                          <a
                                            href={urls[i]?.url}
                                            style={{
                                              color: "inherit",
                                              textDecoration: "inherit",
                                            }}
                                            download={`${urls[i]?.name}.${urls[i]?.type}`}
                                          >
                                            <FileDownloadIcon
                                              style={{
                                                marginLeft: 32,
                                                cursor: "pointer",
                                              }}
                                            />
                                          </a>
                                        </Grid>
                                      </Mob>
                                    ) : (
                                      <Grid item>
                                        <ClearIcon
                                          onClick={() =>
                                            deleteDocument(urls[i]?.key)
                                          }
                                          style={{
                                            marginLeft: 32,
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Grid>
                                    )}
                                  </Paper>
                                );
                              }
                            })}
                        </>
                      )}
                      <br />
                      {!del ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Button onClick={handleOpenDoc}>Add Document</Button>
                          <Button
                            onClick={() => setDelete(true)}
                            style={{ color: "red" }}
                          >
                            Delete Document
                          </Button>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={12} lg={12}>
                          <Button onClick={() => setDelete(false)}>
                            Cancel
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>

              <Card mb={6}>
                <CardContent>
                  <Grid container spacing={5}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Typography variant="h4" gutterBottom>
                        Update Status Notification
                      </Typography>
                    </Grid>
                    {Object.keys(details?.notification_setting).map(
                      (status, i) => {
                        return (
                          <>
                            <Grid item xs={6} md={6} lg={4}>
                              <FormControl
                                fullWidth
                                component="fieldset"
                                variant="standard"
                                // disabled
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={notification[status]}
                                      onChange={handleNotification}
                                      name={status}
                                    />
                                  }
                                  label={_.upperCase(status)}
                                />
                              </FormControl>
                            </Grid>
                          </>
                        );
                      }
                    )}
                    <Grid item xs={12} md={12} lg={12}>
                      <Button onClick={updateNotifications}>
                        Update Settings
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <Grid item xs={12} lg={12} md={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  Update
                </Button>
              </Grid>
            </div>
          ) : (
            <Loading />
          )}
        </form>
      )}
    </Formik>
  );
}

const getDetails = async (
  setDetails,
  setLoader,
  id,
  setPlates,
  setInventory,
  setUrls
) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const inventory = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory?page=1&limit=100`,
      config
    );
    if (inventory.data.success) {
      setInventory(inventory.data.data.data);
    }

    const plateData = await axios.get(
      `/api/v1/${authData?.type}/customer_company/${id}/plate`,
      config
    );
    // console.log("plate Data is", plateData);

    if (plateData.data.success) {
      setPlates(plateData.data.data.data);
    }

    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company/${id}`,
      config
    );
    if (data.success) {
      setDetails(data.data);
      setLinks(data.data.documents, setUrls, setLoader);
    }

    // setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

const setLinks = (document, setUrls, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document.map((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });
    sendRequests(urls, setUrls, setLoader);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setUrls, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setLoader(false);
    }
    let n = 0;
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);
            setUrls((prev) => [
              ...prev,
              { url: url, name: l.name, type: l.type, key: l.key },
            ]);
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);
            setUrls((prev) => [
              ...prev,
              { url: url, name: l.name, type: l.type, key: l.key },
            ]);
          }
          if (n === num) {
            setLoader(false);
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    console.log(e);
  }
};

function UpdateCustomerCompany({ auths }) {
  const [details, setDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [inventory, setInventory] = useState([]);
  const [plates, setPlates] = useState([]);
  const { company_id } = useParams();
  const [urls, setUrls] = useState([]);
  const [up, setup] = useState(0);

  useEffect(() => {
    getDetails(
      setDetails,
      setLoader,
      company_id,
      setPlates,
      setInventory,
      setUrls
    );
  }, []);
  useEffect(() => {
    if (up) {
      getDetails(
        setDetails,
        setLoader,
        company_id,
        setPlates,
        setInventory,
        setUrls
      );
    }
  }, [up]);
  if (loader) {
    return <Loading />;
  } else {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE CUSTOMER COMPANY
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link
                component={NavLink}
                to="/dashboard/company/customer-companies"
              >
                Customer Companies
              </Link>
              <Typography>Update Customer Company</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Update
              user={auths?.user}
              inventory={inventory}
              plates={plates}
              id={company_id}
              urls={urls}
              details={details}
              up={up}
              setup={setup}
              setUrls={setUrls}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(UpdateCustomerCompany);
